import {generateKey} from "../../../utils/helpers";

const yearText = gettext("year");
const activeText = gettext(", will be active until");
const activeText2 = gettext("Will be active until");
const pay_now = gettext("Get it now:");
const pay_now_text = gettext("Get it now: %s ");
const pay_now_text_sponsored = gettext("Get it now:");
const vatText = gettext("Including 8.1% VAT");
const monthlyText = gettext("/ month");
const yearlyBillText = gettext("Billed annually at");
const isAuthenticated = catalogModule.isAuthenticated();
// const is_affiliated = catalogModule.isAffiliated();
const userCountry = catalogModule.getUserCountry();
const vatTax = 1.081;
import {formatEuro, isAboutExpire30} from "../helper/helpers";
const productSource = catalogModule.getSource();

const euroText = formatEuro();
// const isServer = false;
export const CountryPackagePrice = (props) => {
    const [showMonthPrice, setShowMonthPrice] = React.useState(true);
    const [showActiveText, setShowActiveText] = React.useState(true);
    let productPackage = props.productPackage;
    let yearlySubsPrice = productPackage.sponsored ? parseFloat(productPackage.sponsored_price) : parseFloat(productPackage.price);
    let to_pay_price = productPackage.hasOwnProperty("effective_price") ? productPackage.effective_price : 0;
    let to_pay_sponsor = productPackage.hasOwnProperty("effective_sponsored_price") ? productPackage.effective_sponsored_price : 0;
    to_pay_price = productPackage.sponsored ? to_pay_sponsor : to_pay_price;
    let rawMonthlyPrice = productPackage.hasOwnProperty('monthly_price') ? parseFloat(productPackage.monthly_price) : 0;
    let rawMonthlySponsorPrice = productPackage.hasOwnProperty('monthly_sponsored_price') ? parseFloat(productPackage.monthly_sponsored_price) : 0;
    let monthlyPrice = productPackage.sponsored ? rawMonthlySponsorPrice : rawMonthlyPrice;
    let isWithin30Days = isAboutExpire30(productPackage.expiration_date_ts);
    const sponsoredText =  productPackage.hasOwnProperty("sponsored_amount_display") ? interpolate(gettext("DISCOUNT: %(reduction)s OFF"), {reduction: productPackage.sponsored_amount_display}, true) : gettext("SPONSOR DISCOUNT UP TO 15% OFF");

    // let monthlySubsPrice;
    // if(isServer){
    //     if(productPackage.hasOwnProperty('monthly_sponsored_price') && productPackage.hasOwnProperty('monthly_price')){
    //         monthlySubsPrice = productPackage.sponsored ? parseFloat(productPackage.monthly_sponsored_price) : parseFloat(productPackage.monthly_price);
    //         rawMonthlyPrice = parseFloat(productPackage.monthly_price);
    //     } else {
    //         monthlySubsPrice = yearlySubsPrice / 12;
    //     }
    // } else {
    //     let calculateMonthlyPrice = yearlySubsPrice / 12;
    //     monthlySubsPrice = formatDecimal(calculateMonthlyPrice, 2);
    // }
    // If user has a profile country CHE
    if(userCountry === "CHE"){
        yearlySubsPrice *= vatTax;
        to_pay_price *= vatTax;
        rawMonthlyPrice *= vatTax;
        rawMonthlySponsorPrice *= vatTax;
        monthlyPrice *= vatTax;
    }
    rawMonthlyPrice = rawMonthlyPrice.toFixed(2)
    rawMonthlySponsorPrice = rawMonthlySponsorPrice.toFixed(2);
    yearlySubsPrice = yearlySubsPrice.toFixed(2)
    to_pay_price = to_pay_price.toFixed(2);
    monthlyPrice = monthlyPrice.toFixed(2);
    // formatDecimal(yearlySubsPrice, 2) / 12
    // let sponsor_text = interpolate(gettext("Original price: %s eur"), [parseFloat(productPackage.price)]);
    let priceNowText = interpolate(pay_now_text, [to_pay_price]);
    let pricesNowRender = productPackage.sponsored ? <React.Fragment key={generateKey(productPackage.key)}>{pay_now_text_sponsored} <s className="text-danger">{productPackage.effective_price.toFixed(2)}</s> {to_pay_price}</React.Fragment>
        : <React.Fragment key={generateKey(productPackage.key)}>{priceNowText}</React.Fragment>
    let renderPriceNowText;
    renderPriceNowText = [
        pricesNowRender,
        <React.Fragment key={Math.random() * 100}>{euroText}</React.Fragment>
    ];

    React.useEffect(() => {
        if(props.hasOwnProperty("showMonthPrice")){
            if(!props.showMonthPrice){
                setShowMonthPrice(false)
            }
        }
        if(props.hasOwnProperty("showActiveText")){
            if(!props.showActiveText){
                setShowActiveText(false)
            }
        }
    }, []);
    return (
        <React.Fragment>
            {productPackage.sponsored && <h5><small className="badge rounded-pill has-bg-primary text-wrap">{sponsoredText}</small></h5>}
            <h3 className="has-text-anp">
                { showMonthPrice && productPackage.sponsored && <s className="text-danger is-font-normal"> {rawMonthlyPrice}{euroText}</s>}&nbsp;
                { showMonthPrice && <React.Fragment>{monthlyPrice} {euroText} {monthlyText}</React.Fragment> }
                {/*{!isAuthenticated && !productPackage.hasOwnProperty('can_purchase') && ` /${yearText}`}*/}
                <span>
                    {productPackage.can_purchase && isAuthenticated && productPackage.buttonRender === "upgrade" && productSource !== "paypal" && <i className="pb-1 pt-3">{renderPriceNowText} {activeText} {productPackage.exp_date}</i>}
                    {showActiveText && props.isUserPackage4_12 && productPackage.can_purchase && isAuthenticated && productPackage.buttonRender === "upgrade" && productSource === "paypal" && <i>{activeText2} {productPackage.exp_date}</i>}
                    {userCountry === "CHE" && <i>{vatText}</i>}
                    {productPackage.can_purchase && productPackage.buttonRender !== "upgrade" && <i>{yearlyBillText} {yearlySubsPrice} {euroText}</i>}
                    {/* Shows only on new package that is about to expire 30 days with source PAYPAL */}
                    {props.isUserPackage4_12 && isAuthenticated && isWithin30Days && productPackage.buttonRender === "upgrade" && productSource === "paypal" && <i>{renderPriceNowText} {activeText} {productPackage.exp_date}</i>}
                    {/* Shows only on old package with source PAYPAL */}
                    {!props.isUserPackage4_12 && isAuthenticated && productPackage.buttonRender === "upgrade" && productSource === "paypal" && <i>{renderPriceNowText} {activeText} {productPackage.exp_date}</i>}
                    {/* Shows only on new package with source PAYPAL */}
                    {props.isUserPackage4_12 && isAuthenticated && productPackage.buttonRender === "upgrade" && productSource === "paypal" && <i>{renderPriceNowText} {activeText} {productPackage.exp_date}</i>}
                </span>
            </h3>
            <br/>
        </React.Fragment>
    )
}

export const DumbCountryPackagePrice = (props) => {
    let productPackage = props.productPackage;
    let yearlySubsPrice = productPackage.sponsored ? parseFloat(productPackage.sponsored_price) : parseFloat(productPackage.price);
    let to_pay_price = productPackage.hasOwnProperty("effective_price") ? productPackage.effective_price : 0;
    let to_pay_sponsor = productPackage.hasOwnProperty("effective_sponsored_price") ? productPackage.effective_sponsored_price : 0;
    to_pay_price = productPackage.sponsored ? to_pay_sponsor : to_pay_price;
    let rawMonthlyPrice = productPackage.hasOwnProperty('monthly_price') ? parseFloat(productPackage.monthly_price) : 0;
    let rawMonthlySponsorPrice = productPackage.hasOwnProperty('monthly_sponsored_price') ? parseFloat(productPackage.monthly_sponsored_price) : 0;
    let monthlyPrice = productPackage.sponsored ? rawMonthlySponsorPrice : rawMonthlyPrice;
    let isWithin30Days = isAboutExpire30(productPackage.expiration_date_ts);
    const sponsoredText =  productPackage.hasOwnProperty("sponsored_amount_display") ? interpolate(gettext("DISCOUNT: %(reduction)s OFF"), {reduction: productPackage.sponsored_amount_display}, true) : gettext("SPONSOR DISCOUNT UP TO 15% OFF");

    if(userCountry === "CHE"){
        yearlySubsPrice *= vatTax;
        to_pay_price *= vatTax;
        rawMonthlyPrice *= vatTax;
        rawMonthlySponsorPrice *= vatTax;
        monthlyPrice *= vatTax;
    }
    rawMonthlyPrice = rawMonthlyPrice.toFixed(2)
    rawMonthlySponsorPrice = rawMonthlySponsorPrice.toFixed(2);
    yearlySubsPrice = yearlySubsPrice.toFixed(2)
    to_pay_price = to_pay_price.toFixed(2);
    monthlyPrice = monthlyPrice.toFixed(2);
    // formatDecimal(yearlySubsPrice, 2) / 12
    // let sponsor_text = interpolate(gettext("Original price: %s eur"), [parseFloat(productPackage.price)]);
    let priceNowText = interpolate(pay_now_text, [to_pay_price]);
    let pricesNowRender = productPackage.sponsored ? <React.Fragment key={generateKey(productPackage.key)}>{pay_now_text_sponsored} <s className="text-danger">{productPackage.effective_price.toFixed(2)}</s> {to_pay_price}</React.Fragment>
        : <React.Fragment key={generateKey(productPackage.key)}>{priceNowText}</React.Fragment>
    let renderPriceNowText;
    renderPriceNowText = [
        pricesNowRender,
        <React.Fragment key={Math.random() * 100}>{euroText}</React.Fragment>
    ];
    return (
        <React.Fragment>
            { props.showSponBadge && <h5><small className="badge rounded-pill has-bg-primary text-wrap">{sponsoredText}</small></h5>}
            <h3 className="has-text-anp">
                { props.showSponMonthPrice && <s className="text-danger is-font-normal"> {rawMonthlyPrice}{euroText}</s>}&nbsp;
                { props.showMonthPrice && <React.Fragment>{monthlyPrice} {euroText} {monthlyText}</React.Fragment>}
                {/*{` /${yearText}`}*/}
                <span>
                    { props.showGetItPhrase && <i className="pb-1 pt-3">{renderPriceNowText} {activeText} {productPackage.exp_date}</i>}
                    { props.showActiveText && <i className="my-1">{activeText2} {productPackage.exp_date}</i>}
                    {userCountry === "CHE" && <i className="my-1">{vatText}</i>}
                    { props.showBillAnnually && <i>{yearlyBillText} {yearlySubsPrice} {euroText}</i>}
                    { props.showGetItPhrase2 && <i>{renderPriceNowText} {activeText} {productPackage.exp_date}</i> }
                </span>
            </h3>
            <br/>
        </React.Fragment>
    )
}

export const CountryPackageNotAuthPrice = (props) => {
    let productPackage = props.productPackage;
    let yearlySubsPrice = productPackage.sponsored ? parseFloat(productPackage.sponsored_price) : parseFloat(productPackage.price);
    let to_pay_price = productPackage.hasOwnProperty("effective_price") ? productPackage.effective_price : 0;
    let to_pay_sponsor = productPackage.hasOwnProperty("effective_sponsored_price") ? productPackage.effective_sponsored_price : 0;
    to_pay_price = productPackage.sponsored ? to_pay_sponsor : to_pay_price;
    let rawMonthlyPrice = productPackage.hasOwnProperty('monthly_price') ? parseFloat(productPackage.monthly_price) : 0;
    let rawMonthlySponsorPrice = productPackage.hasOwnProperty('monthly_sponsored_price') ? parseFloat(productPackage.monthly_sponsored_price) : 0;
    let monthlyPrice = productPackage.sponsored ? rawMonthlySponsorPrice : rawMonthlyPrice;
    const sponsoredText =  productPackage.hasOwnProperty("sponsored_amount_display") ? interpolate(gettext("DISCOUNT: %(reduction)s OFF"), {reduction: productPackage.sponsored_amount_display}, true) : gettext("SPONSOR DISCOUNT UP TO 15% OFF");
    // let monthlySubsPrice;
    // if(isServer){
    //     if(productPackage.hasOwnProperty('monthly_sponsored_price') && productPackage.hasOwnProperty('monthly_price')){
    //         monthlySubsPrice = productPackage.sponsored ? parseFloat(productPackage.monthly_sponsored_price) : parseFloat(productPackage.monthly_price);
    //         rawMonthlyPrice = parseFloat(productPackage.monthly_price);
    //     } else {
    //         monthlySubsPrice = yearlySubsPrice / 12;
    //     }
    // } else {
    //     let calculateMonthlyPrice = yearlySubsPrice / 12;
    //     monthlySubsPrice = formatDecimal(calculateMonthlyPrice, 2);
    // }
    // If user has a profile country CHE
    if (userCountry === "CHE") {
        yearlySubsPrice *= vatTax;
        to_pay_price *= vatTax;
        rawMonthlyPrice *= vatTax;
        rawMonthlySponsorPrice *= vatTax;
        monthlyPrice *= vatTax;
    }
    rawMonthlyPrice = rawMonthlyPrice.toFixed(2);
    rawMonthlySponsorPrice = rawMonthlySponsorPrice.toFixed(2);
    yearlySubsPrice = yearlySubsPrice.toFixed(2);
    to_pay_price = to_pay_price.toFixed(2);
    monthlyPrice = monthlyPrice.toFixed(2);
    // formatDecimal(yearlySubsPrice, 2) / 12
    // let sponsor_text = interpolate(gettext("Original price: %s eur"), [parseFloat(productPackage.price)]);
    let priceNowText = interpolate(pay_now_text, [to_pay_price]);
    let renderPriceNowText;
    renderPriceNowText = [
        <React.Fragment key={generateKey(productPackage.key)}>{priceNowText}</React.Fragment>,
        <React.Fragment key={Math.random() * 100}>{euroText}</React.Fragment>
    ];
    return (
        <React.Fragment>
            { productPackage.sponsored && <h5><small className="badge rounded-pill has-bg-primary text-wrap">{sponsoredText}</small></h5>}
            <h3 className="has-text-anp">
                {productPackage.sponsored && <s className="text-danger is-font-normal"> {rawMonthlyPrice}{euroText}</s>}&nbsp;
                { <React.Fragment>{monthlyPrice} {euroText} {monthlyText}</React.Fragment> }
                {/*{` /${yearText}`}*/}
                <span>
                    <i className="pb-1 pt-3">{activeText2} {productPackage.exp_date}</i>
                    <i>{yearlyBillText} {yearlySubsPrice} {euroText}</i>
                </span>
            </h3>
            <br/>
        </React.Fragment>
    )
}

export const CountryPackageZeroPrice = (props) => {
    let productPackage = props.productPackage;
    let subscriptionPrice = parseFloat(productPackage.price);
    if(userCountry === "CHE"){
        subscriptionPrice *= vatTax;
    }
    return (
        <React.Fragment>
            <h3>
                {subscriptionPrice} {euroText}
                {!isAuthenticated && !productPackage.hasOwnProperty('can_purchase') && ` /${yearText}`}
                <span>
                    {productPackage.can_purchase && <i className="pb-1 pt-3">{activeText} {productPackage.exp_date}</i>}
                    {userCountry === "CHE" && <i>{vatText}</i>}
                </span>
            </h3>
            <br/>
        </React.Fragment>
    )
}

